import { ReactNode } from "react";
import XTermLog from "./XTermLog";

interface LogsPlaceholderProps {
    title?: ReactNode;
    extra?: ReactNode;
    height?: string;
}

const FETCHING_LOGS_PLACEHOLDER = `⏳ \u001b[36mFetching logs...\u001b[0m`;

const LogsPlaceholder = ({ title, extra, height }: LogsPlaceholderProps) => {
    return (
        <XTermLog
            logs={[{ content: FETCHING_LOGS_PLACEHOLDER }]}
            height={height}
            title={title}
            extra={extra}
            className="content-logs"
        />
    );
}

export default LogsPlaceholder;
